import iconStatusOnline from '../assets/icon/statusOnline.svg';
import iconStatusAusente from '../assets/icon/statusAusente.svg';
import iconStatusOcupado from '../assets/icon/statusOcupado.svg';
import iconStatusOffLine from '../assets/icon/statusOffLine.svg';

import { userStatus } from '../enums/userStatus';

export const getInitials = (name: string): string => {
  const words = name.trim().split(' ');
  let initials = '';

  if (words.length === 1) {
    // Se houver apenas um nome, pegue as duas primeiras letras
    initials = words[0].substring(0, 2);
  } else {
    // Se houver mais de um nome, pegue a primeira letra do primeiro nome
    // e a primeira letra do último nome
    initials = words[0][0] + words[words.length - 1][0];
  }

  return initials.toUpperCase();
};

export const getStatusIcon = (status: number): string => {
  if (status === userStatus.Online) return iconStatusOnline;
  if (status === userStatus.Ausente) return iconStatusAusente;
  if (status === userStatus.Ocupado) return iconStatusOcupado;
  return iconStatusOffLine;
};

export const getPrimeiroUltimoNome = (nomeCompleto: string): string => {
  const nomes = nomeCompleto.trim().split(/\s+/); // Divide por espaços e remove espaços extras
  if (nomes.length === 1) {
    return nomes[0]; // Retorna o único nome se só houver um
  }
  return `${nomes[0]} ${nomes[nomes.length - 1]}`; // Retorna o primeiro e o último nome
};

export const calculateColumnWidth = (
  numBars: number,
  minWidth: number,
  maxWidth: number
): string => {
  const availableWidth = 100; // Assumindo 100% como largura total disponível

  // Calcula o percentual da largura com base no número de barras, de forma inversamente proporcional
  const calculatedWidth = availableWidth / numBars;

  // Inverte a proporção: quanto mais registros, menor a largura e vice-versa
  const invertedWidth = availableWidth - calculatedWidth;

  // Limita o percentual entre o mínimo e o máximo especificados
  const width = Math.min(Math.max(invertedWidth, minWidth), maxWidth);

  return `${width}%`;
};

export const unescapeHtml = (text: string): string => {
  return text
    .replace(/&amp;/g, '&') // Deve ser o último
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
};
